import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { format } from 'util';
import { AuthService } from '../../services/Auth/auth.service';
import { MenuAuthService } from '../../services/common/menu-auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { from } from 'rxjs';
import {AESEncryptDecryptService} from '../../services/aesencrypt-decrypt.service'
declare var $: any;    

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  public Menu: any;
  public displayName: string;
  public userRole: string;
  public isAgent = false;
  message: string;

  constructor(
    private auth: AESEncryptDecryptService,
    private _AuthService: AuthService,
    private router: Router,
    private menuAuth: MenuAuthService
  ) { }

  ngOnInit() {
    const agentData: string | null = localStorage.getItem("agent##");
    if (agentData) this.isAgent = true;
    this.menuAuth.currentMessage.subscribe(message => this.message = message);
    this.Menu = JSON.parse(localStorage.getItem("menuItem") || '[]');
    this.displayName = localStorage.getItem('displayName') || '';
    this.userRole = localStorage.getItem('role') || 'User';

    this.initSidebarToggle();
  }
  getRoute(path: string): string {
    return path.startsWith('admin') ? `/${path}` : `/admin/${path}`;
  }
  initSidebarToggle() {
    // Add click handlers for treeview items
    setTimeout(() => {
      const treeviewItems = document.querySelectorAll('.treeview > a');
      treeviewItems.forEach(item => {
        item.addEventListener('click', function(e) {
          const parent = this.parentElement;
          const sibling = this.nextElementSibling;

          if (sibling && sibling.classList.contains('treeview-menu')) {
            e.preventDefault();
            parent.classList.toggle('open');
          }
        });
      });
    }, 0);
  }

  isActiveRoute(route: string): boolean {
    return this.router.url === '/admin/dashboard';
  }

  newMessage(obj:any, modules:any) {
    const str = JSON.stringify({ is_delete_permission: modules.is_delete_permisssion });
    const encrypt = this.auth.encrypt(str);
    window.localStorage.setItem('perms', encrypt);
    this.menuAuth.changeMessage(obj);
  }

  logoutAdmin() {
    this._AuthService.logout().subscribe(
      (res: any) => {
        this.router.navigate(['/']);
        const myItem = window.localStorage.getItem('user##');
        setTimeout(() => {
          window.location.reload();
        }, 100);
        // window.localStorage.clear();
        if (myItem) window.localStorage.setItem('user##', myItem);
      });
  }




  GoToDashboard() {
    this.router.navigate(['admin/dashboard']);
  }

  changePassword() {
    this.router.navigate(['/admin/change-password']);
  }
}